import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SoundKitListModel } from 'src/app/models/sound-kit-list.model';
import { FinalFilterModel } from 'src/app/models/filter';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { SoundKitService } from 'src/app/services/sound/sound-kit.service';
import { Subscription } from 'rxjs';
import { FilterListModel, FilterSubsListObj } from 'src/app/models/filter-list-model';
import FILTER_JSON from 'src/assets/data/filter-list-sound.json';

@Component({
  selector: 'ipm-royalty-free',
  templateUrl: './royalty-free.component.html',
  styleUrls: ['./royalty-free.component.scss']
})
export class RoyaltyFreeComponent implements OnInit, OnDestroy {
  royaltyFreeList: Array<SoundKitListModel> = [];
  isDataLoaded: boolean = false;
  isShowLoaderPagination: boolean = false;
  isShowFilter: boolean = true;
  filterData: FinalFilterModel;
  countOfData: number = 0;
  paginationSubscription: Subscription;
  queryParamsSubscription: Subscription;

  constructor(
    public commonFunction: CommonService,
    public routerActivated: ActivatedRoute,
    private router: Router,
    private soundKitService: SoundKitService
  ) {}

  ngOnInit(): void {
    this.routerActivated.data.subscribe((data: any) => {
      this.commonFunction.setTitleService(data['title']);
    });

    this.filterData = this.soundKitService.filterDataInit();
    this.getBeatCategories();

    setTimeout(() => {
      this.queryParamsSubscription = this.routerActivated.queryParams.subscribe((params: Params) => {
        this.filterData = this.soundKitService.filterDataInit();

        if (Object.keys(params).length > 0) {
          this.commonFunction.urlKeysList.map(item => {
            if (item.type === 'search') {
              this.commonFunction.selectedSearchInputValue = params['sV'];
              this.commonFunction.setSearchDropdown(params['sK']);
            } else {
              this.commonFunction.filterOptionList.filter((filterItem: FilterListModel) => {
                if (filterItem.filter_type === 'swipes-menu' || filterItem.filter_type === 'swipes-menu-bpm-offer') {
                  filterItem.filter_sub_list = filterItem.filter_sub_list.filter(sliderObj => {
                    if (sliderObj.urlLabelName) {
                      if (filterItem.filter_type === 'swipes-menu-bpm-offer') {
                        sliderObj.isSelected = params[sliderObj.urlLabelName] === sliderObj?.key;
                      } else {
                        sliderObj.isSelected = params[sliderObj.urlLabelName] === 'true';
                      }
                    }
                    return sliderObj;
                  });
                } else {
                  if (params[filterItem.urlLabelName]) {
                    if (filterItem.filter_type === 'multiselect') {
                      filterItem.filter_selected_values = this.setMultiDropDownValue(params[filterItem.urlLabelName], filterItem);
                    } else {
                      filterItem.filter_sub_list = this.setMultiDropDownValue(params[filterItem.urlLabelName], filterItem);
                    }
                  }
                }
              });
            }
          });

          let finalFilterData = this.commonFunction.setFilterValuesForBeats(params);
          if (Object.keys(params).length) {
            this.filterData = { ...this.filterData, ...finalFilterData };
            this.countOfData = 0;
            this.royaltyFreeList = [];
          }
        }

        this.loadRoyaltyFreeSoundKits();
      });
    });

    this.paginationSubscription = this.commonFunction.isCallingPagination.subscribe(() => {
      this.isCallingPagination();
    });
  }

  ngOnDestroy(): void {
    if (this.paginationSubscription) {
      this.paginationSubscription.unsubscribe();
    }

    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }

  isCallingPagination(): void {
    let url: string = this.router.url.split('/')[this.router.url.split('/').length - 1];
    if (
      this.royaltyFreeList.length > 0 &&
      this.countOfData !== 0 &&
      this.countOfData === this.filterData.page.limit &&
      this.commonFunction.isCheckCurrentUrlMatch(url)
    ) {
      let currentLimit: any = this.filterData.page.offset + this.filterData.page.limit;
      if (currentLimit) {
        this.filterData.page.offset = currentLimit;
        this.loadRoyaltyFreeSoundKits('pagination');
      }
    }
  }

  loadRoyaltyFreeSoundKits(callingType: string = ''): void {
    let isShowLoader = callingType && callingType === 'pagination' ? false : true;
    this.isDataLoaded = !isShowLoader;
    this.isShowLoaderPagination = callingType && callingType === 'pagination' ? true : false;

    this.soundKitService.getRoyaltyFreeKits(this.filterData, isShowLoader).subscribe({
      next: (result) => {
        let royaltyFreeBeats: Array<SoundKitListModel> = result;
        this.setRoyaltyFreeSoundKitsList(royaltyFreeBeats, callingType, result.length);
      },
      error: (error) => {
        this.commonFunction.showToastError(error);
        this.isDataLoaded = true;
        this.isShowLoaderPagination = false;
      }
    });
  }

  setRoyaltyFreeSoundKitsList(royaltyFreeList: Array<SoundKitListModel>, callingType: string, sourceCount: number = 0): void {
    if (royaltyFreeList.length > 0) {
      if (!callingType) {
        this.royaltyFreeList = royaltyFreeList;
      } else {
        this.royaltyFreeList = [...this.royaltyFreeList, ...royaltyFreeList];
      }
    }
    this.countOfData = sourceCount;
    this.isDataLoaded = true;
    this.isShowLoaderPagination = false;
  }

  navigateToSoundKits(): void {
    this.router.navigate(['/soundkits']);
  }

  getBeatCategories(): void {
    this.commonFunction.filterOptionList = FILTER_JSON;
  }

  setMultiDropDownValue(params: any, filterCurrent: FilterListModel): Array<FilterSubsListObj> {
    let selectedFilterValue: Array<FilterSubsListObj> = [];
    if (params) {
      let paramsValue: Array<string> = filterCurrent.filter_type === 'multiselect' ? params.split(',') : params.split('-');
      if (filterCurrent.filter_type === 'multiselect') {
        paramsValue.map((key: string) => {
          let foundObj = filterCurrent.filter_sub_list.find((filterObj: FilterSubsListObj) => filterObj.key === key);
          if (foundObj) {
            selectedFilterValue.push(foundObj);
          }
        });
      } else {
        filterCurrent.filter_sub_list[0].starting_range = paramsValue[0];
        filterCurrent.filter_sub_list[0].end_range = paramsValue[1];
      }
    }
    return filterCurrent.filter_type === 'multiselect' ? selectedFilterValue : filterCurrent.filter_sub_list;
  }
}
